"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFields = AddressFields;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
const i18nIsoCountries = __importStar(require("i18n-iso-countries"));
const normalize_string_1 = require("@src/helpers/normalize-string");
const config_1 = __importDefault(require("@src/config"));
function AddressFields({ intl, rules }) {
    const { addressRules, cityRules, postalCodeRules } = rules;
    const countries = react_1.default.useMemo(() => Object.entries(i18nIsoCountries.getNames('sk')), []);
    return ((0, jsx_runtime_1.jsxs)(antd_1.Col, { xs: 24, md: 12, children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'admin.company_info_edit_form.country',
                }), name: types_1.CompanyInfoEditFormField.country, initialValue: config_1.default.countryCode, rules: [{ required: true, message: intl.formatMessage({ id: 'admin.company_info_edit_form.country.fill' }) }], children: (0, jsx_runtime_1.jsx)(antd_1.Select, { showSearch: true, optionFilterProp: "children", filterOption: (input, option) => (0, normalize_string_1.normalizeStr)(option.children).indexOf((0, normalize_string_1.normalizeStr)(input)) >= 0, children: countries.map(([code, name]) => ((0, jsx_runtime_1.jsx)(antd_1.Select.Option, { value: code, children: name }, code))) }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'admin.company_info_edit_form.adress',
                }), name: types_1.CompanyInfoEditFormField.street_address, rules: addressRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'admin.company_info_edit_form.city',
                }), name: types_1.CompanyInfoEditFormField.city, rules: cityRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) }), (0, jsx_runtime_1.jsx)(antd_1.Row, { gutter: [16, 16], children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, md: 12, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                            id: 'admin.company_info_edit_form.postal_code',
                        }), name: types_1.CompanyInfoEditFormField.postal_code, rules: postalCodeRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) }) }) })] }));
}
